import TableRow from "@component/common/TableRow";
import TableText from "@component/common/TableText";
import PostPopper from "./PostPopper";
import { POST_INFO } from "@constant/POST_INFO";
import { PostValueProps } from "@interface/post";
import { formatDateToYYYYMMDD } from "@util/date";
import { CommunityData, CommunityType } from "@entity/community.entity";

export default function PostValue({ post }: PostValueProps) {
  return (
    <TableRow
      children={POST_INFO.map(({ WIDTH }, index) => {
        return (
          <TableText width={WIDTH}>{PostTableContent(index, post)}</TableText>
        );
      })}
      popper={<PostPopper post={post} />}
    />
  );
}

function PostTableContent(
  index: number,
  { communityType, title, likeCount, scrapCount, createdDate }: CommunityData
) {
  switch (index) {
    case 0:
      return getCommunityTypeLabel(communityType);
    case 1:
      return title;
    case 2:
      return `${likeCount ?? 0} / ${scrapCount ?? 0}`;
    case 3:
      return formatDateToYYYYMMDD(new Date(createdDate));
    default:
      return null;
  }
}

function getCommunityTypeLabel(type: CommunityType | string): string {
  const typeMap: Record<string, string> = {
    [CommunityType.NOTICE]: "공지",
    [CommunityType.NUTRIENT_STORY]: "영양스토리",
    [CommunityType.SUCCESS_STORY]: "도전인생샷",
    [CommunityType.BUSINESS_STORY]: "비즈니스스토리",
    [CommunityType.QNA]: "Q&A",
  };
  return typeMap[type] || type;
}
